import io from "socket.io-client";

const SocketClient = io.connect("/", {
  path: "/socket.io",
  transports: ["websocket", "polling"],
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 3,
});
SocketClient.on("connect", () => {
  SocketClient.io.engine.on("upgrade", () => {});
});

SocketClient.on("connect_error", () => {});
export default SocketClient;
